
export enum UserRole {
  STUDENT = 'STUDENT',
  ADMIN = 'ADMIN'
}

export interface User {
  id: string;
  username: string;
  password?: string; // 用于本地模拟校验
  role: UserRole;
}

export interface Word {
  id: string;
  english: string;
  pos: string;
  chinese: string;
  unit: string;
  isPriority?: boolean;
}

export interface UserProgress {
  userId: string;
  username: string;
  wordId: string;
  correctCount: number;
  wrongCount: number;
  lastReviewStatus: 'correct' | 'wrong' | 'forgot' | 'none';
}
